import { Component, OnInit } from '@angular/core';
import { BillersService } from 'src/app/services/billers.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-payment-source-biller-success',
  templateUrl: './payment-source-biller-success.component.html',
  styleUrls: ['./payment-source-biller-success.component.scss']
})
export class PaymentSourceBillerSuccessComponent implements OnInit {
  amount
  locations
  selectedLocation
  markers = []
  previous
  lat: number 
  lng: number
  postalCode
  show
  lastPage
  currentPage = 1
  constructor(public billerService : BillersService, private common : CommonService) { }

ngOnInit(): void {
  this.amount = this.billerService.qr_amount
  this.locations =  this.billerService.ps_locations
  // this.selectedLocation = this.locations[0]
  this.setupMap()
  
}

setupMap(){
  if(this.locations.length){
    this.markers = []
    this.locations.forEach((location,i) => {
      this.markers.push({
        lat : location.latitude,
        lng : location.longitude,
        draggable: false,
        label : i,
        title : location.location_name
      })
    });
    this.lat = +this.locations[0].latitude
    this.lng = +this.locations[0].longitude
  }
  else{
    this.show = true
  }
}

assignCoordinates(lat, lon, location){
  this.markers = []
  this.selectedLocation = location
  this.lat = +lat
  this.lng =  +lon
  this.markers.push({
    lat : location.latitude,
    lng : location.longitude,
    draggable: false,
    // label : i,
    title : location.location_name
  })
}

clickedMarker(infowindow) {
  if (this.previous && this.markers.length>1) {
      this.previous.close();
  }
  this.previous = infowindow;
}

getLocationByPostal(){
  this.common.showLoader()
  this.billerService.getLocationByPostalCode(this.postalCode, 1).subscribe((res:any) => {
    this.locations = res.data.data
    this.common.stopLoader()
    this.setupMap()
  }, err => {
    this.show = true
    this.common.stopLoader()
  })
 }


 nextPage(){
  if(this.lastPage != this.currentPage){
    this.common.showLoader()
     this.currentPage += 1
     this.billerService.getLocationByPostalCode(this.postalCode || this.billerService.auth.user.zip_code, this.currentPage).subscribe((res:any) => {
       this.lastPage = res.data.last_page
       this.locations = res.data.data
       this.setupMap()
       this.common.stopLoader()
     }, err => {
         this.show = true
         this.common.stopLoader()
     })
   }
   
 }

 
 prevPage(){
   if(this.currentPage != 1){
     this.common.showLoader()
     this.currentPage -= 1
     this.billerService.getLocationByPostalCode(this.postalCode || this.billerService.auth.user.zip_code, this.currentPage).subscribe((res:any) => {
       this.lastPage = res.data.last_page
       this.locations = res.data.data
       this.setupMap()
       this.common.stopLoader()
     }, err => {
         this.show = true
         this.common.stopLoader()
     })
   }
 }

 checkDisabled(type){
   if(type=='prev'){
     return this.currentPage == 1 ? true : false
   }
   else if( type == 'next'){
     return this.currentPage == this.lastPage ? true : false
   }
 }
}
